import styled from "styled-components";

export const View = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  > .max-width,
  > .max-width > div,
  > .max-width .MuiFormControl-root,
  > .max-width .MuiInputBase-root {
    width: 300px;
    min-width: 300px;
    max-width: 300px;
  }

  > .file-input-full-width,
  > .file-input-full-width > div,
  > .full-width,
  > .full-width > div {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  label {
    span {
      white-space: nowrap;
    }
  }
`;

export const FullWidthFeedback = styled.div`
  width: 100%;

  > div {
    width: 100%;
    max-width: 100%;
  }
`;